
import { WorldCountry } from '../types';

export const portugalData: WorldCountry = {
  code: 'PT',
  name: 'Portugal',
  slug: 'portugal',
  population: 10300000,
  topCities: [
    { name: 'Lisbon', slug: 'lisbon-portugal', population: 2870000 },
    { name: 'Porto', slug: 'porto-portugal', population: 1760000 },
    { name: 'Braga', slug: 'braga-portugal', population: 193000 },
    { name: 'Setúbal', slug: 'setubal-portugal', population: 118000 },
    { name: 'Coimbra', slug: 'coimbra-portugal', population: 105000 },
    { name: 'Funchal', slug: 'funchal-portugal', population: 105000 },
    { name: 'Almada', slug: 'almada-portugal', population: 101000 },
    { name: 'Aveiro', slug: 'aveiro-portugal', population: 80000 },
    { name: 'Viseu', slug: 'viseu-portugal', population: 57000 },
    { name: 'Guimarães', slug: 'guimaraes-portugal', population: 53000 },
    { name: 'Leiria', slug: 'leiria-portugal', population: 63000 },
    { name: 'Faro', slug: 'faro-portugal', population: 118000 },
    { name: 'Portimão', slug: 'portimao-portugal', population: 55000 },
    { name: 'Castelo Branco', slug: 'castelo-branco-portugal', population: 35000 },
    { name: 'Évora', slug: 'evora-portugal', population: 57000 },
    { name: 'Vila Nova de Gaia', slug: 'vila-nova-de-gaia-portugal', population: 302000 },
    { name: 'Amadora', slug: 'amadora-portugal', population: 175000 },
    { name: 'Matosinhos', slug: 'matosinhos-portugal', population: 175000 },
    { name: 'Gondomar', slug: 'gondomar-portugal', population: 164000 },
    { name: 'Vila Franca de Xira', slug: 'vila-franca-de-xira-portugal', population: 137000 },
    { name: 'Loures', slug: 'loures-portugal', population: 205000 },
    { name: 'Odivelas', slug: 'odivelas-portugal', population: 144000 },
    { name: 'Sintra', slug: 'sintra-portugal', population: 377000 },
    { name: 'Cascais', slug: 'cascais-portugal', population: 206000 },
    { name: 'Vila do Conde', slug: 'vila-do-conde-portugal', population: 79000 },
    { name: 'Maia', slug: 'maia-portugal', population: 135000 },
    { name: 'Póvoa de Varzim', slug: 'povoa-de-varzim-portugal', population: 64000 },
    { name: 'Rio Tinto', slug: 'rio-tinto-portugal', population: 54000 },
    { name: 'Barcelos', slug: 'barcelos-portugal', population: 61000 },
    { name: 'Santa Maria da Feira', slug: 'santa-maria-da-feira-portugal', population: 139000 },
    
    // Expansión: 70 ciudades adicionales para llegar a 100 total
    { name: 'Vila Real', slug: 'vila-real-portugal', population: 51000 },
    { name: 'Santarém', slug: 'santarem-portugal', population: 61000 },
    { name: 'Bragança', slug: 'braganca-portugal', population: 35000 },
    { name: 'Viana do Castelo', slug: 'viana-do-castelo-portugal', population: 88000 },
    { name: 'Lamego', slug: 'lamego-portugal', population: 27000 },
    { name: 'Chaves', slug: 'chaves-portugal', population: 41000 },
    { name: 'Mirandela', slug: 'mirandela-portugal', population: 24000 },
    { name: 'Peso da Régua', slug: 'peso-da-regua-portugal', population: 17000 },
    { name: 'Penafiel', slug: 'penafiel-portugal', population: 71000 },
    { name: 'Santo Tirso', slug: 'santo-tirso-portugal', population: 71000 },
    { name: 'Famalicão', slug: 'famalicao-portugal', population: 133000 },
    { name: 'Valongo', slug: 'valongo-portugal', population: 94000 },
    { name: 'Paredes', slug: 'paredes-portugal', population: 86000 },
    { name: 'Lousada', slug: 'lousada-portugal', population: 47000 },
    { name: 'Felgueiras', slug: 'felgueiras-portugal', population: 58000 },
    { name: 'Paços de Ferreira', slug: 'pacos-de-ferreira-portugal', population: 56000 },
    { name: 'Marco de Canaveses', slug: 'marco-de-canaveses-portugal', population: 53000 },
    { name: 'Amarante', slug: 'amarante-portugal', population: 56000 },
    { name: 'Celorico de Basto', slug: 'celorico-de-basto-portugal', population: 20000 },
    { name: 'Mondim de Basto', slug: 'mondim-de-basto-portugal', population: 8000 },
    { name: 'Baião', slug: 'baiao-portugal', population: 20000 },
    { name: 'Resende', slug: 'resende-portugal', population: 11000 },
    { name: 'Cinfães', slug: 'cinfaes-portugal', population: 20000 },
    { name: 'Castelo de Paiva', slug: 'castelo-de-paiva-portugal', population: 17000 },
    { name: 'Águeda', slug: 'agueda-portugal', population: 47000 },
    { name: 'Oliveira do Bairro', slug: 'oliveira-do-bairro-portugal', population: 23000 },
    { name: 'Vagos', slug: 'vagos-portugal', population: 23000 },
    { name: 'Ílhavo', slug: 'ilhavo-portugal', population: 38000 },
    { name: 'Murtosa', slug: 'murtosa-portugal', population: 10000 },
    { name: 'Estarreja', slug: 'estarreja-portugal', population: 26000 },
    { name: 'Ovar', slug: 'ovar-portugal', population: 55000 },
    { name: 'Oliveira de Azeméis', slug: 'oliveira-de-azemeis-portugal', population: 68000 },
    { name: 'São João da Madeira', slug: 'sao-joao-da-madeira-portugal', population: 22000 },
    { name: 'Vale de Cambra', slug: 'vale-de-cambra-portugal', population: 23000 },
    { name: 'Arouca', slug: 'arouca-portugal', population: 22000 },
    { name: 'Espinho', slug: 'espinho-portugal', population: 31000 },
    { name: 'Santa Maria de Lamas', slug: 'santa-maria-de-lamas-portugal', population: 15000 },
    { name: 'São Pedro do Sul', slug: 'sao-pedro-do-sul-portugal', population: 17000 },
    { name: 'Vouzela', slug: 'vouzela-portugal', population: 11000 },
    { name: 'Castro Daire', slug: 'castro-daire-portugal', population: 15000 },
    { name: 'Oliveira de Frades', slug: 'oliveira-de-frades-portugal', population: 10000 },
    { name: 'Tondela', slug: 'tondela-portugal', population: 28000 },
    { name: 'Carregal do Sal', slug: 'carregal-do-sal-portugal', population: 10000 },
    { name: 'Mortágua', slug: 'mortagua-portugal', population: 9000 },
    { name: 'Santa Comba Dão', slug: 'santa-comba-dao-portugal', population: 12000 },
    { name: 'Penalva do Castelo', slug: 'penalva-do-castelo-portugal', population: 7000 },
    { name: 'Mangualde', slug: 'mangualde-portugal', population: 19000 },
    { name: 'Nelas', slug: 'nelas-portugal', population: 14000 },
    { name: 'Gouveia', slug: 'gouveia-portugal', population: 14000 },
    { name: 'Seia', slug: 'seia-portugal', population: 25000 },
    { name: 'Fornos de Algodres', slug: 'fornos-de-algodres-portugal', population: 5000 },
    { name: 'Celorico da Beira', slug: 'celorico-da-beira-portugal', population: 8000 },
    { name: 'Trancoso', slug: 'trancoso-portugal', population: 10000 },
    { name: 'Aguiar da Beira', slug: 'aguiar-da-beira-portugal', population: 5000 },
    { name: 'Penedono', slug: 'penedono-portugal', population: 3000 },
    { name: 'São João da Pesqueira', slug: 'sao-joao-da-pesqueira-portugal', population: 8000 },
    { name: 'Tabuaço', slug: 'tabuaco-portugal', population: 6000 },
    { name: 'Armamar', slug: 'armamar-portugal', population: 6000 },
    { name: 'Tarouca', slug: 'tarouca-portugal', population: 8000 },
    { name: 'Moimenta da Beira', slug: 'moimenta-da-beira-portugal', population: 10000 },
    { name: 'Sernancelhe', slug: 'sernancelhe-portugal', population: 6000 },
    { name: 'Penedono', slug: 'penedono-alt-portugal', population: 3000 },
    { name: 'Vila Nova de Paiva', slug: 'vila-nova-de-paiva-portugal', population: 6000 },
    { name: 'Castelo Branco', slug: 'castelo-branco-alt-portugal', population: 56000 },
    { name: 'Idanha-a-Nova', slug: 'idanha-a-nova-portugal', population: 10000 },
    { name: 'Penamacor', slug: 'penamacor-portugal', population: 6000 },
    { name: 'Vila Velha de Ródão', slug: 'vila-velha-de-rodao-portugal', population: 4000 },
    { name: 'Proença-a-Nova', slug: 'proenca-a-nova-portugal', population: 8000 },
    { name: 'Oleiros', slug: 'oleiros-portugal', population: 5000 },
    { name: 'Sertã', slug: 'serta-portugal', population: 16000 },
    { name: 'Vila de Rei', slug: 'vila-de-rei-portugal', population: 3000 },
    { name: 'Mação', slug: 'macao-portugal', population: 7000 },
    { name: 'Fundão', slug: 'fundao-portugal', population: 29000 }
  ]
};
